export default __webpack_public_path__ + "static/media/scribe.c6d02296.jpg";